/*******************************************************************************
 *
 * This file is part of the LGS1920/studio project.
 *
 * File: style.css
 *
 * Author : LGS1920 Team
 * email: studio@lgs1920.fr
 *
 * Created on: 2026-01-06
 * Last modified: 2026-01-06
 *
 *
 * Copyright © 2026 LGS1920
 ******************************************************************************/

.lgs-text-value {
    display: flex;
    gap: var(--lgs-gutter-s);
}

.lgs-nvu-unit {
    margin-left: 3px;
}
